var map = {
	"./base/assets/images-offers/acquiring.png": 36014,
	"./base/assets/images-offers/exception.png": 5746,
	"./base/assets/images-offers/image1.png": 86411,
	"./base/assets/images-offers/image2.png": 18885,
	"./base/assets/images-offers/image3.png": 29094,
	"./base/assets/images-offers/image4.png": 36282,
	"./base/assets/images-offers/image6.png": 70823,
	"./base/assets/images-offers/image7.png": 66686,
	"./base/assets/images-offers/kyc.svg": 45686,
	"./base/assets/images-offers/quickDeposit.png": 77833,
	"./base/assets/images-offers/quickDepositMobile.png": 76242,
	"./base/assets/images-offers/referralProgram.png": 69741,
	"./base/assets/images-offers/services.png": 1758,
	"./base/assets/images-offers/support.png": 62514,
	"./base/assets/images-offers/welcome.png": 13815,
	"./base/assets/images/2FAOval.svg": 22709,
	"./base/assets/images/2faImg.svg": 90691,
	"./base/assets/images/Cancelled.svg": 36074,
	"./base/assets/images/CardActiveOvalWhite.svg": 17067,
	"./base/assets/images/CardFrozenOvalWhite.svg": 17537,
	"./base/assets/images/CardOvalGray.svg": 8520,
	"./base/assets/images/CreditCards.svg": 91911,
	"./base/assets/images/Failed.svg": 35699,
	"./base/assets/images/Finnished.svg": 73615,
	"./base/assets/images/PDF-preview.svg": 82328,
	"./base/assets/images/Pending.svg": 24945,
	"./base/assets/images/Processing.svg": 66768,
	"./base/assets/images/Reverted.svg": 82167,
	"./base/assets/images/TradingDesk.svg": 58679,
	"./base/assets/images/aboutImgOne.png": 58631,
	"./base/assets/images/aboutImgTwo.png": 23812,
	"./base/assets/images/accountProfileMenu.svg": 22171,
	"./base/assets/images/active-programme.svg": 68395,
	"./base/assets/images/add-account.svg": 71888,
	"./base/assets/images/addMoneyOval.svg": 8964,
	"./base/assets/images/addPerson.svg": 28919,
	"./base/assets/images/addedPerson.svg": 49362,
	"./base/assets/images/address.svg": 41302,
	"./base/assets/images/alert-error.svg": 37515,
	"./base/assets/images/alert-info.svg": 76706,
	"./base/assets/images/alert-warning-yellow.svg": 57989,
	"./base/assets/images/alert-warning.svg": 69978,
	"./base/assets/images/arrowDown.png": 83630,
	"./base/assets/images/arrowKeyboardRight.svg": 37558,
	"./base/assets/images/arrowLeft.svg": 63155,
	"./base/assets/images/arrowUp.svg": 62880,
	"./base/assets/images/attachFilesPlus.svg": 16389,
	"./base/assets/images/availableCards/physicalBlack.png": 79522,
	"./base/assets/images/availableCards/physicalGoldGTI.png": 67579,
	"./base/assets/images/availableCards/physicalHills.png": 86018,
	"./base/assets/images/availableCards/physicalPheonixBlack.png": 93071,
	"./base/assets/images/availableCards/physicalPhoenixWhite.png": 43438,
	"./base/assets/images/availableCards/physicalPlatinumGTI.png": 5701,
	"./base/assets/images/availableCards/physicalStandardGTI.png": 99937,
	"./base/assets/images/availableCards/virtualBlack.png": 54618,
	"./base/assets/images/availableCards/virtualDefault.png": 63329,
	"./base/assets/images/availableCards/virtualFoxpay.png": 19619,
	"./base/assets/images/availableCards/virtualGTI.png": 39383,
	"./base/assets/images/availableCards/virtualHills.png": 16712,
	"./base/assets/images/availableCards/virtualPhoenix.png": 89128,
	"./base/assets/images/bankAcc.svg": 60200,
	"./base/assets/images/bankAccountOvalWhite.svg": 41088,
	"./base/assets/images/bankAccountRoundDarkGrey.svg": 20472,
	"./base/assets/images/bankAccountRoundGrey.svg": 1116,
	"./base/assets/images/basketGrey.svg": 51229,
	"./base/assets/images/blueArrowDown.svg": 45685,
	"./base/assets/images/blueArrowUp.svg": 99637,
	"./base/assets/images/business.svg": 52714,
	"./base/assets/images/businessProfile.svg": 58800,
	"./base/assets/images/buyAsstesOval.svg": 327,
	"./base/assets/images/buyCardOval.svg": 61257,
	"./base/assets/images/calendar.svg": 64589,
	"./base/assets/images/card.svg": 11010,
	"./base/assets/images/cardBackCVC.svg": 83266,
	"./base/assets/images/cardDeactivate.svg": 36882,
	"./base/assets/images/cardFreeze.svg": 58473,
	"./base/assets/images/cardHideDetails.svg": 79295,
	"./base/assets/images/cardHidePin.svg": 32386,
	"./base/assets/images/cardShowDetails.svg": 23757,
	"./base/assets/images/cardShowPin.svg": 67990,
	"./base/assets/images/cardUnfreeze.svg": 91088,
	"./base/assets/images/check.svg": 38698,
	"./base/assets/images/check_circle.svg": 8755,
	"./base/assets/images/checked-grey-circle.svg": 28271,
	"./base/assets/images/checked-grey-hover.svg": 96715,
	"./base/assets/images/checked-grey.svg": 64856,
	"./base/assets/images/close.svg": 79022,
	"./base/assets/images/closeButton.svg": 30146,
	"./base/assets/images/commentCloud.svg": 76889,
	"./base/assets/images/confirmAddress.svg": 51661,
	"./base/assets/images/contact.png": 13038,
	"./base/assets/images/contactImgOne.png": 32613,
	"./base/assets/images/copy-icon.svg": 49606,
	"./base/assets/images/credit-card-dark-grey.svg": 55634,
	"./base/assets/images/dashboardLinkIcon.svg": 27950,
	"./base/assets/images/deactive.svg": 30683,
	"./base/assets/images/deviceBrowser.svg": 8453,
	"./base/assets/images/deviceCardsApp.svg": 91733,
	"./base/assets/images/deviceMobileApp.svg": 1666,
	"./base/assets/images/document-upload-thumb.svg": 24950,
	"./base/assets/images/document.svg": 11402,
	"./base/assets/images/documents.svg": 71117,
	"./base/assets/images/downloadFileIcon.svg": 88118,
	"./base/assets/images/downloadOval.svg": 72116,
	"./base/assets/images/dragndropmark.svg": 35069,
	"./base/assets/images/dropZoneUpload.svg": 45711,
	"./base/assets/images/edit.svg": 17285,
	"./base/assets/images/email-confirm.png": 30235,
	"./base/assets/images/email2fa.svg": 66497,
	"./base/assets/images/error-circle.svg": 93151,
	"./base/assets/images/errors/403.png": 65055,
	"./base/assets/images/errors/404.png": 76348,
	"./base/assets/images/errors/503.png": 35640,
	"./base/assets/images/errors/serverError.svg": 4391,
	"./base/assets/images/errors/serverOffline.svg": 11866,
	"./base/assets/images/exchangeOval.svg": 70433,
	"./base/assets/images/failure-circle.svg": 30472,
	"./base/assets/images/favourite.svg": 55835,
	"./base/assets/images/favouriteBordered.svg": 98216,
	"./base/assets/images/file-icon-oval.svg": 59558,
	"./base/assets/images/floatingCard.svg": 68597,
	"./base/assets/images/foxPayCheck.svg": 87467,
	"./base/assets/images/freeze.svg": 23142,
	"./base/assets/images/generic.svg": 90508,
	"./base/assets/images/google-authenticator.svg": 93057,
	"./base/assets/images/hammer.svg": 57775,
	"./base/assets/images/hide-pin.svg": 58665,
	"./base/assets/images/inactive-programme.svg": 41934,
	"./base/assets/images/lang/ar.svg": 56936,
	"./base/assets/images/lang/cn.svg": 1679,
	"./base/assets/images/lang/de.svg": 41710,
	"./base/assets/images/lang/en.svg": 88944,
	"./base/assets/images/lang/es.svg": 3587,
	"./base/assets/images/lang/fr.svg": 39907,
	"./base/assets/images/lang/in.svg": 62819,
	"./base/assets/images/lang/it.svg": 88753,
	"./base/assets/images/lang/lt.svg": 22255,
	"./base/assets/images/lang/ru.svg": 48043,
	"./base/assets/images/lang/tr.svg": 49331,
	"./base/assets/images/ledgers/adaOval.svg": 52961,
	"./base/assets/images/ledgers/aedOval.svg": 31065,
	"./base/assets/images/ledgers/air777Oval.svg": 7796,
	"./base/assets/images/ledgers/atriOval.svg": 84998,
	"./base/assets/images/ledgers/btcIcon.svg": 47442,
	"./base/assets/images/ledgers/btcOval.svg": 34916,
	"./base/assets/images/ledgers/chfOval.svg": 32180,
	"./base/assets/images/ledgers/cruOval.svg": 76491,
	"./base/assets/images/ledgers/dogeOval.svg": 70064,
	"./base/assets/images/ledgers/dwrldOval.svg": 45205,
	"./base/assets/images/ledgers/eosOval.svg": 55023,
	"./base/assets/images/ledgers/ethOval.svg": 89080,
	"./base/assets/images/ledgers/eurOval.svg": 98092,
	"./base/assets/images/ledgers/ftmOval.svg": 35252,
	"./base/assets/images/ledgers/gbpOval.svg": 98246,
	"./base/assets/images/ledgers/gxagOval.svg": 14807,
	"./base/assets/images/ledgers/lif3Oval.svg": 65332,
	"./base/assets/images/ledgers/mt760Oval.svg": 62412,
	"./base/assets/images/ledgers/mt777Oval.svg": 97408,
	"./base/assets/images/ledgers/paugOval.svg": 27072,
	"./base/assets/images/ledgers/pauxOval.svg": 37839,
	"./base/assets/images/ledgers/rlxOval.svg": 4647,
	"./base/assets/images/ledgers/sgdOval.svg": 92078,
	"./base/assets/images/ledgers/shibOval.svg": 71892,
	"./base/assets/images/ledgers/solOval.svg": 84254,
	"./base/assets/images/ledgers/trxOval.svg": 56118,
	"./base/assets/images/ledgers/untbOval.svg": 67993,
	"./base/assets/images/ledgers/usdOval.svg": 55215,
	"./base/assets/images/ledgers/usdcOval.svg": 83799,
	"./base/assets/images/ledgers/usdtOval.svg": 31759,
	"./base/assets/images/ledgers/usduOval.svg": 7106,
	"./base/assets/images/ledgers/vetOval.svg": 8346,
	"./base/assets/images/ledgers/wbtcOval.svg": 68705,
	"./base/assets/images/ledgers/wcruOval.svg": 3510,
	"./base/assets/images/ledgers/xagOval.svg": 40594,
	"./base/assets/images/ledgers/xauOval.svg": 66805,
	"./base/assets/images/ledgers/xptOval.svg": 97959,
	"./base/assets/images/ledgers/xrpOval.svg": 19949,
	"./base/assets/images/limitedTokensServices.svg": 59283,
	"./base/assets/images/linkingAccount.png": 88500,
	"./base/assets/images/logout.svg": 83412,
	"./base/assets/images/mastercardLogo.svg": 27821,
	"./base/assets/images/metalServices.svg": 55569,
	"./base/assets/images/metals.svg": 77319,
	"./base/assets/images/navBar.svg": 23224,
	"./base/assets/images/note.svg": 21185,
	"./base/assets/images/otherServices.svg": 42007,
	"./base/assets/images/package.svg": 75778,
	"./base/assets/images/pencil.svg": 29236,
	"./base/assets/images/personalProfile.svg": 46545,
	"./base/assets/images/phone2Fa.svg": 82760,
	"./base/assets/images/physicalcardOval.svg": 10430,
	"./base/assets/images/pin-code.svg": 13760,
	"./base/assets/images/plus-active.svg": 23683,
	"./base/assets/images/plus-dark-grey.svg": 70508,
	"./base/assets/images/plus-grey.svg": 62154,
	"./base/assets/images/plus-white.svg": 43530,
	"./base/assets/images/priceTag.svg": 23587,
	"./base/assets/images/printOval.svg": 33989,
	"./base/assets/images/profile-circle-active.svg": 60467,
	"./base/assets/images/profile-oval-dark-grey.svg": 81660,
	"./base/assets/images/profile-oval.svg": 26417,
	"./base/assets/images/profile.svg": 39010,
	"./base/assets/images/referral/1.svg": 28159,
	"./base/assets/images/referral/2.svg": 67879,
	"./base/assets/images/referral/3.svg": 59664,
	"./base/assets/images/referral/facebook.svg": 9228,
	"./base/assets/images/referral/finish.svg": 5137,
	"./base/assets/images/referral/linkedin.svg": 55387,
	"./base/assets/images/referral/success.svg": 73767,
	"./base/assets/images/referral/twitter.svg": 61858,
	"./base/assets/images/referral/whatsapp.svg": 40402,
	"./base/assets/images/referralsIcon.svg": 96030,
	"./base/assets/images/refresh.svg": 77221,
	"./base/assets/images/refreshGrey.svg": 24255,
	"./base/assets/images/refund.svg": 14487,
	"./base/assets/images/security-warn-fab.svg": 56278,
	"./base/assets/images/selectDropDownArrow.svg": 39692,
	"./base/assets/images/sellOval.svg": 84913,
	"./base/assets/images/sepaOval.svg": 9953,
	"./base/assets/images/servicePlans/cards.svg": 91977,
	"./base/assets/images/servicePlans/crypto.svg": 8901,
	"./base/assets/images/servicePlans/ibans.svg": 65237,
	"./base/assets/images/servicePlans/metals.svg": 23202,
	"./base/assets/images/servicePlans/plan_bg.png": 54857,
	"./base/assets/images/servicePlans/stocks.svg": 3063,
	"./base/assets/images/settingsLinkIcon.svg": 61309,
	"./base/assets/images/shipping.svg": 74092,
	"./base/assets/images/sourceOfFunds.svg": 91690,
	"./base/assets/images/success-circle-gray.svg": 2169,
	"./base/assets/images/success-circle.svg": 34108,
	"./base/assets/images/successBig.svg": 98806,
	"./base/assets/images/support.svg": 5098,
	"./base/assets/images/supportIconOvalWhite.svg": 89751,
	"./base/assets/images/swiftOval.svg": 24260,
	"./base/assets/images/switchAccount.svg": 43197,
	"./base/assets/images/tooltip-info.svg": 12697,
	"./base/assets/images/trading-desk-logo.svg": 96788,
	"./base/assets/images/transactionsLinkIcon.svg": 34527,
	"./base/assets/images/transfer.svg": 32288,
	"./base/assets/images/transferOval.svg": 83948,
	"./base/assets/images/truck-circle.svg": 29765,
	"./base/assets/images/truck.svg": 93525,
	"./base/assets/images/ukLocalOval.svg": 50280,
	"./base/assets/images/unfreeze.svg": 37363,
	"./base/assets/images/upload-documents.svg": 38746,
	"./base/assets/images/virtualcardOval.svg": 59884,
	"./base/assets/images/visaLogo.svg": 87772,
	"./base/assets/images/visibility-off.svg": 5902,
	"./base/assets/images/visibility-on.svg": 32334,
	"./base/assets/images/waiting.svg": 76993,
	"./base/assets/images/warning-triangle.svg": 35336,
	"./base/assets/images/warningCloud.svg": 39913,
	"./base/assets/images/x.svg": 33420,
	"./base/assets/images/x_hover.svg": 86954,
	"./base/assets/images/x_red.svg": 40478,
	"./development/assets/images/logo.svg": 59448,
	"./development/assets/landing/images/bg.jpg": 73628,
	"./development/assets/landing/images/bg_mobile.jpg": 13502,
	"./development/assets/landing/images/logo.svg": 97929,
	"./development/assets/landing/images/logo_mobile.svg": 43264,
	"./swisstech/assets/images/logo.svg": 12720,
	"./swisstech/assets/landing/images/bg.jpg": 70894,
	"./swisstech/assets/landing/images/bg_mobile.jpg": 3114,
	"./swisstech/assets/landing/images/logo.svg": 54955,
	"./swisstech/assets/landing/images/logo_mobile.svg": 97545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9241;